import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatchedLeadsProductPublicDto } from '@/app/models/public';

@Component({
  selector: 'app-company-card',
  templateUrl: './company-card.component.html',
  imports: [
    RouterLink,
    MatButtonModule,
    MatIconModule,
  ],
})
export class CompanyCardComponent {
  company = input.required<MatchedLeadsProductPublicDto>();

  // slug comes directly from the DTO now
  slug = computed(() => this.company().slug);

  // phone lives on the nested CompanyPublicDto
  phone = computed(() => this.company().company?.phone ?? null);

  phoneHref = computed(() =>
    this.phone()?.replace(/[^+\d]/g, '') ?? null
  );

  profileSnippet = computed(() => {
    const text  = this.company().profileDetails ?? '';
    const words = text.replace(/<[^>]*>/g, '').trim().split(/\s+/);
    return words.length > 20
      ? words.slice(0, 20).join(' ') + '...'
      : words.join(' ');
  });

  imageUrl = computed(() => this.company().company?.imageUrl ?? null);

  // admins flag companies to be highlighted (and listed first) on the companies page
  featured = computed(() => !!this.company().featuredOnCompaniesPage);
}
